
















































import {Vue, Component} from "vue-property-decorator";
import MyForm from "../MyForm";
import router from "../router";


@Component({})
export default class Login extends Vue {

    public message = '';
    public isBadCredentials = false;

    public form = new MyForm({
        email: "",
        password: ""
    });


    login() {
        this.$store
            .dispatch("auth/login", this.form)
            .then(data => {
                this.form.reset();
                router.replace({name: "Home"});
            })
            .catch(error => {
                if (error.response.data.code === 400) {
                    this.isBadCredentials = true;
                    this.message = error.response.data.message;
                }
                this.form.error = error.response.data.errors;
            });
    }

    forgetPassword(){
        router.replace({name: "ForGetPassword"})
    }
}
